import { useEffect, useMemo, useRef } from 'react';

import { isEqual } from 'lodash';

import { ChangeDetectorContextModel } from '../../../../../../shared/components/change-detector-context/models/change-detector-context.model';
import { AppDetailFormFormikModel } from '../../models/app-detail-form-formik.model';

export const useIsFormModified = (
  iconId: number | null,
  screenshotsIds: number[],
  formikValues: AppDetailFormFormikModel,
  cdContext: ChangeDetectorContextModel
) => {
  const initialValuesRef = useRef<AppDetailFormFormikModel | null>(null);

  useEffect(() => {
    if (!initialValuesRef.current && iconId !== null) {
      initialValuesRef.current = {
        ...formikValues,
        iconId,
        screenshotsIds,
      };
    }
  }, [iconId, screenshotsIds]);

  const isFormModified = useMemo(() => {
    if (!initialValuesRef.current) {
      return false;
    }
    return !isEqual(
      { ...formikValues, iconId, screenshotsIds },
      initialValuesRef.current
    );
  }, [formikValues, iconId, screenshotsIds]);

  useEffect(() => {
    cdContext.setIsChanged(isFormModified);
  }, [isFormModified]);
};
